<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="导出"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          :model="exportControlBoxInspection"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-form-item label="扫描时间" prop="inspectionDate">
          <el-date-picker
              v-model="exportControlBoxInspection.inspectionDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择时间"/>
        </el-form-item>
        <el-form-item label="控制柜" prop="inspectionType">
          <el-select v-model="exportControlBoxInspection.inspectionType" style="width: 220px" clearable placeholder="请选择">
            <el-option
                v-for="item in constants.inspectionTypes.$options"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="exportLoading" type="primary" @click="exportExcel">导出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constants from "../../../util/constants";

  export default {
    name:"ExportControlBoxInspection",
    components: {},
    data() {
      return {
        dialogVisible: false,
        exportLoading: false,
        constants,
        exportControlBoxInspection: {
          inspectionDate: "",
          inspectionType: "",
          filter:"",
        },
        ruleValidate: {
          inspectionDate: {required: true, message: "不能为空", trigger: "blur"},
          inspectionType: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
      },
      //导出
      exportExcel() {
        console.log(this.exportControlBoxInspection);
        this.exportLoading = true;
        this.$http
          .exportFileByPost("basic","controlBoxInspections/selectByDay", this.exportControlBoxInspection)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            console.log(fileName);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
